import Blibli4You from "../../../assets/images/projects/blibli-4-you/thumbnail.png";
import { ProjectDataProps } from "../props";

export default {
  title: "Blibli Hackathon: Blibli4You",
  description: "How might we turned 24 hours idea into engagement features",
  image: Blibli4You,
  path: "/blibli-4-you",
} as ProjectDataProps;
